var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
let SearchElement = class SearchElement extends Vue {
    constructor() {
        super(...arguments);
        this.searchText = "";
    }
    onSubmit() {
        return {
            searchText: this.searchText,
        };
    }
    created() { this.searchText = this.defaultSearchText; }
    onTextChanged(val, _oldVal) { this.searchText = val; }
};
__decorate([
    Prop({ required: true })
], SearchElement.prototype, "defaultSearchText", void 0);
__decorate([
    Inject()
], SearchElement.prototype, "i18n", void 0);
__decorate([
    Emit("search-request")
], SearchElement.prototype, "onSubmit", null);
__decorate([
    Watch("defaultSearchText")
], SearchElement.prototype, "onTextChanged", null);
SearchElement = __decorate([
    Component({
        name: "SearchElement",
    })
], SearchElement);
export default SearchElement;
